import { useEffect, useRef, useState } from "react";
import { fetchTicker } from "../lib/api";
import { logError } from "../lib/logger";

const TV_WIDGET_SRC =
    "https://s3.tradingview.com/external-embedding/embed-widget-ticker-tape.js";

const TV_CONFIG = {
    symbols: [
        { proName: "FX:EURUSD", title: "EUR/USD" },
        { proName: "FX:GBPUSD", title: "GBP/USD" },
        { proName: "FX:USDJPY", title: "USD/JPY" },
        { proName: "FX:USDCHF", title: "USD/CHF" },
        { proName: "FX:AUDUSD", title: "AUD/USD" },
        { proName: "FX:USDCAD", title: "USD/CAD" },
        { proName: "FX:NZDUSD", title: "NZD/USD" },
        { proName: "OANDA:XAUUSD", title: "Gold" },
        { proName: "BITSTAMP:BTCUSD", title: "BTC/USD" },
        { proName: "BITSTAMP:ETHUSD", title: "ETH/USD" },
        { proName: "BINANCE:SOLUSDT", title: "SOL/USD" },
        { proName: "BINANCE:XRPUSDT", title: "XRP/USD" },
        { proName: "BINANCE:ADAUSDT", title: "ADA/USD" },
        { proName: "BINANCE:DOGEUSDT", title: "DOGE/USD" },
    ],
    showSymbolLogo: true,
    isTransparent: true,
    displayMode: "adaptive",
    colorTheme: "dark",
    locale: "en",
};

export function useTradingViewWidget(containerRef) {
    const mountedRef = useRef(false);
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        const container = containerRef.current;
        if (!container || mountedRef.current) return undefined;
        mountedRef.current = true;

        const script = document.createElement("script");
        script.src = TV_WIDGET_SRC;
        script.async = true;
        script.type = "text/javascript";
        // Static JSON config (no user input) — required by TradingView's embed API.
        script.text = JSON.stringify(TV_CONFIG);
        container.appendChild(script);

        const check = setTimeout(() => {
            if (container.querySelector("iframe")) setLoaded(true);
        }, 5000);
        return () => clearTimeout(check);
    }, [containerRef]);

    return loaded;
}

export function useFallbackTicker() {
    const [items, setItems] = useState([]);

    useEffect(() => {
        let mounted = true;
        const load = async () => {
            try {
                const data = await fetchTicker();
                if (mounted) setItems(data);
            } catch (err) {
                logError("Fallback ticker fetch failed:", err);
            }
        };
        load();
        const id = setInterval(load, 5000);
        return () => {
            mounted = false;
            clearInterval(id);
        };
    }, []);

    return items;
}
